import { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { consumeMagicLink } from '../../lib/portal'

export default function AuthCallbackPage() {
  const [params] = useSearchParams()
  const navigate = useNavigate()
  const [error, setError] = useState<string | null>(null)
  const ran = useRef(false)

  useEffect(() => {
    if (ran.current) return
    ran.current = true
    const token = params.get('token')
    if (!token) { setError('Bağlantı geçersiz.'); return }
    consumeMagicLink(token)
      .then(() => navigate('/dashboard', { replace: true }))
      .catch(() => setError('Bağlantı geçersiz, süresi dolmuş veya zaten kullanılmış.'))
  }, [params, navigate])

  return (
    <>
      <Helmet><title>Giriş — W.Sign</title><meta name="robots" content="noindex, nofollow" /></Helmet>
    <section className="container-page py-16 max-w-md">
      {error ? (
        <div className="card border-red-200 bg-red-50">
          <h1 className="text-lg font-semibold text-red-800">Giriş başarısız</h1>
          <p className="mt-2 text-sm text-red-700">{error}</p>
          <Link to="/login" className="btn-primary mt-4 inline-block">Yeni bağlantı iste</Link>
        </div>
      ) : (
        <p className="text-sm text-[var(--color-fg-muted)]">Giriş yapılıyor…</p>
      )}
    </section>
    </>
  )
}
